export default {"src":"/_next/static/media/fida.8a9f756b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};